import React from 'react';
import * as Iconos from '../UI/Iconos.js';
import styles from './Iconos.module.css';

export const IconoOrganizador = (props) => {
  const objeto = props.objeto;

  if (objeto && objeto.organizador) {
    return <img src={Iconos.gol} alt="Organizador" className={styles.icono} title="Organizador" />;
  }

  return null;
};
